import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'

import {TeacherContext} from 'teacher/context'
import ClearableSelect from 'components/clearable-select'

const useStyles = makeStyles(filterStyles)

export default function StudentAnsweredAssessmentsFilters() {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const history = useHistory()

  const {translate, query, linkQuery, groupId, gradingCategories} = context
  const location = useLocation()

  const {items: periods} = context.rollbookContextPeriods

  const createFilterHandler = (name, mapQuery) => (event) => {
    const value = event.target.value == '' ? undefined : event.target.value
    const query = mapQuery
      ? mapQuery(context.query, value)
      : {...context.query, [name]: value}
    history.push(linkQuery(location.pathname, {...query}))
  }


  return (
    <Box className={classes.root}>
    {periods.length > 0 && (
      <ClearableSelect
        id="student-answered-assessment-period-filter"
        className={clsx(classes.select, "period")}
        value={context.query.periodId || ""}
        onChange={createFilterHandler('periodId')}
        caption={translate('period-filter')}
      >
      {periods.map((period, key) => {
        return (<MenuItem value={period.id} key={key}>{period.properties.name}</MenuItem>)
      })}
      </ClearableSelect>
    )}
    {gradingCategories.length > 0 && (
      <ClearableSelect
        id="student-answered-assessment-category-filter"
        className={clsx(classes.select, "type")}
        value={context.query.typeId || ""}
        onChange={createFilterHandler('typeId')}
        caption={translate('category-filter')}
      >
        {gradingCategories.map((type, key) => {
        return (<MenuItem value={type.id} key={key}>{translate(`${type.name}-label`)}</MenuItem>)
      })}
      </ClearableSelect>
    )}
  </Box>)
}

function filterStyles() {
  return {
    root: {
      display: "flex",
      padding: '0 15px 15px 15px',
      display: 'flex',
      border: 'solid 1px #dbe3e6',
      borderRadius: 4,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    },
    select: {
      width: 200,
      '&.type': {
        marginLeft: 30
      }
    },
    filler: {
      flexGrow: 1,
    },
  }
}
